export default __webpack_public_path__ + "static/events-dark-865a665b387fdd178dfd82d49d106d34.png";